import { reactive, ref } from 'vue'
import useValidate from '@/shared/lib/validate'
import { defineStore } from 'pinia'

export const useObjectAdd = defineStore('object_add', () => {
  const { required, number, numberMin } = useValidate()

  const show = ref(false)

  /* Данные формы */
  const data = reactive({
    name: '',
    parent: 0,
    type: 3,
    description: '',
  })

  /* Правила валидации */
  const rules = {
    name: [(value: string) => required(value)],
    parent: [(value: string) => number(value), (value: string) => numberMin(value, 0)],
    object_type: [(value: string) => number(value), (value: string) => numberMin(value, 1)],
  }

  const addParent = (parent: number) => {
    show.value = true
    data.parent = parent
  }

  const close = () => {
    show.value = false
    data.parent = 0
  }

  return {
    data,
    rules,
    show,

    addParent,
    close,
  }
})
